import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const SelfHostedComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "string",
    label: "Environment",
    description: "Allows P0 to provide ssh access to self-hosted compute",
    maturity: "ga",
    schema: {
      environmentLabel: Element({
        label: "Environment label",
        description:
          "Provide an optional user-friendly label for the environment",
        type: "string",
      }),
      userSuffix: Element({
        label: "User suffix",
        description:
          "Provide an optional suffix that will be appended to the linux user name. Helps to avoid conflicts with existing users managed outside of P0",
        type: "string",
      }),
    },
  }),
});
